import { useEffect, useLayoutEffect } from "react";
import { useMatchMedia, BreakPointsEnum } from "@perxis-auto/shared";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../model/index.js";
import { actions } from "../model/slice.js";
const useComparisonSettings = () => {
  const dispatch = useAppDispatch();
  const totalCompared = useAppSelector((state) => selectors.selectTotal(state.comparison));
  const isThreeComparisonColumns = useMatchMedia(BreakPointsEnum.lgMax);
  const isTwoComparisonColumns = useMatchMedia(BreakPointsEnum.mdMax);
  useEffect(() => {
    if (typeof isTwoComparisonColumns === "undefined") {
      return;
    }
    dispatch(actions.setSelected([]));
  }, [dispatch, isTwoComparisonColumns]);
  useEffect(() => {
    if (typeof isThreeComparisonColumns === "undefined" || typeof isTwoComparisonColumns === "undefined") {
      return;
    }
    if (!isThreeComparisonColumns) {
      dispatch(actions.fillSelected(4));
    } else if (!isTwoComparisonColumns) {
      dispatch(actions.fillSelected(3));
    } else {
      dispatch(actions.fillSelected(2));
    }
  }, [totalCompared, isThreeComparisonColumns, isTwoComparisonColumns, dispatch]);
  useLayoutEffect(() => {
    return () => {
      dispatch(actions.setSelected([]));
      dispatch(actions.setShowDifference(false));
    };
  }, [dispatch]);
};
export {
  useComparisonSettings
};
